import './emtNewDetail.scss';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { /* useSearchParams,  */ useParams } from 'react-router-dom';
import CrumbTrail from 'components/features/crumbTrail/CrumbTrail';
import { selectedNewEmtState, updateSelectedEmtNew } from 'redux/slices/newsSlice';
import { useLazyGetNewByIdQuery, useLazyGetNewsCategoriesQuery } from 'redux/services/newsService';
//import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';
import defaultNewImage from 'resources/icons/Screenshot 2024-09-19 104024.png';
import ImagePromise from 'components/widgets/imagePromise/ImagePromise';
import TimeUtils from 'utils/TimeUtils';
import IconPromise from 'components/widgets/IconPromise/IconPromise';
import { scrollTop } from 'utils/utils';
import DOMPurify from 'dompurify';
import { useTranslate } from 'context/languageContext';
import { useLanguage } from 'context/languageContext';
import Image from 'components/commons/image/Image';
import ErrorScreen from 'screens/errorScreen/ErrorScreen';
import EmtNewDetailSkeleton from './component/emtNewDetailSkeleton/EmtNewDetailSkeleton';
import useAnalytics from 'hooks/useAnalytics/useAnalytics';
import UseSEO from 'hooks/useSEO/UseSEO';
//import { accentsTidy } from 'utils/utils';

export default function EmtNewDetail() {
  const t = useTranslate();
  const selectedNewSelector = useSelector(selectedNewEmtState) as any;
  // const [searchParams] = useSearchParams();
  const [GetNewById] = useLazyGetNewByIdQuery();
  const [GetNewsCategories] = useLazyGetNewsCategoriesQuery();
  const [detailedNew, setDetailedNew] = useState<any>(selectedNewSelector);
  const [categoriesData, setCategoriesData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  //const navigate = useNavigate();
  const dispatch = useDispatch();
  // const newId = searchParams.get('newId');
  const { newId } = useParams();
  const currentLanguage = useLanguage();
  const { logEventAnalytics } = useAnalytics();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  const [generateURL, generateTitleAndMeta] = UseSEO();

  useEffect(() => {
    detailedNew && logEventAnalytics('newsDetail_screen', { id: newId, title: detailedNew?.title });
  }, [newId, detailedNew]);

  const renderAnswer = (res) => {
    const htmlContent = res;
    const sanitizedHtmlContent = DOMPurify.sanitize(
      htmlContent,
      /* {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'height', 'width'],
        FORBID_TAGS: ['script'], 
        FORBID_ATTR: ['srcdoc'], 
        ALLOWED_URI_REGEXP: /^(?:(?:https?|ftp):|\/\/)/i 
      } */
    );
    return sanitizedHtmlContent;
  };

  const getCategories = async (categoriesId) => {
    await GetNewsCategories({ language: currentLanguage }).then((categories) => {
      if (categories.isSuccess) {
        const filteredData = categories.data.filter((category) =>
          categoriesId.includes(category.id),
        );
        setCategoriesData(filteredData);
        // if (filteredData.length) ROUTES[3] = setRoutes([...ROUTES, filteredData[0].name]);
      }
    });
  };

  const getSelectedNew = async (selectedNewId) => {
    setLoading(true);
    scrollTop();
    if (selectedNewId) {
      await GetNewById({ newId: selectedNewId, language: currentLanguage })
        .then((result) => {
          let data;
          if (result.isSuccess) {
            dispatch(updateSelectedEmtNew(result.data));
            setDetailedNew(result.data);
            data = result.data;

            //navigate(`/${currentLanguage}/${RUTAS_GENERALES_MUL2.emtNewDetail[currentLanguage]}?newId=${selectedNewId}`);
          }
          return data;
        })
        .then(async (data) => {
          if (data) await getCategories(data.categories);
        })
        .finally(() => setLoading(false));
    }
  };

  const getNewsCrumbTrail = () => {
    // const HOME = { name:t('lb_seo_title_inicio'), url:'/' };
    const EMT = { name: 'EMTPalma', url: `/${RUTAS_GENERALES_MUL2.emt[currentLanguage]}` };
    const NEWS = {
      name: t('lb_noticias'),
      url: `/${RUTAS_GENERALES_MUL2.emtNews[currentLanguage]}`,
    };
    const categoryDataCrumb = categoriesData[0]?.name || t('lb_noticia');
    const CATEGORY = { name: categoryDataCrumb, url: '' };

    const ROUTES = [EMT, NEWS];
    categoryDataCrumb && ROUTES.push(CATEGORY);
    return ROUTES;
  };

  useEffect(() => {
    scrollTop();
    return () => {
      dispatch(updateSelectedEmtNew(null));
    };
  }, []);

  useEffect(() => {
    getSelectedNew(newId);
  }, [selectedNewSelector, currentLanguage, newId]);

  return (
    <>
      {detailedNew ? generateTitleAndMeta(detailedNew?.title, detailedNew?.summary) : null}
      <div className='new-detail-container'>
        {loading ? (
          <div className='emt-new-skeleton-container'>
            <EmtNewDetailSkeleton />
          </div>
        ) : detailedNew ? (
          <>
            <div className='new-detail-route'>
              <CrumbTrail items={getNewsCrumbTrail()} />
            </div>
            <div className='new-detail-header'>
              <div className='title-section'>
                <h1>{detailedNew?.title}</h1>
                <div className='new-detail-categories'>
                  {categoriesData?.map((category, i) => (
                    <span
                      key={`${category.id}-${category.iconId}`}
                      style={{ background: category.color }}
                    >
                      <IconPromise idIcon={category.iconId} />
                      {category.name}
                    </span>
                  ))}
                </div>
                <span id='date'>
                  {`${t('lb_publicado_el')} ${TimeUtils.getFullDate(
                    detailedNew?.publishedAt,
                    currentLanguage,
                    true,
                  )}`}
                </span>
              </div>
            </div>

            {/* BODY */}
            <div className='new-detail-content'>
              {
                <div className='content-img-wrapper'>
                  {detailedNew?.images[0] ? (
                    <ImagePromise imageId={detailedNew?.images[0]} />
                  ) : (
                    <Image src={defaultNewImage} />
                  )}
                </div>
              }
              <p id='new-detail-summary'>{detailedNew?.summary}</p>
              <div
                id='new-detail-description'
                dangerouslySetInnerHTML={{ __html: renderAnswer(detailedNew?.description) }}
              ></div>
            </div>
          </>
        ) : (
          <ErrorScreen errorCode={404} message={t('lb_noticia_no_existe')} />
        )}
      </div>
    </>
  );
}
